export default {
    addTab({ commit }, route) {
        commit('ADD_TAB', {
            title: route.meta.title,
            fullPath: route.fullPath,
            path: route.path,
            lastVisited: Date.now()
        })
    },

    removeTab({ commit }, fullPath) {
        commit('REMOVE_TAB', fullPath)
    },

    setActiveTab({ commit }, fullPath) {
        commit('SET_ACTIVE_TAB', fullPath)
    }
}